<template>
  <div class="container">
    <h1>Users</h1>
    <div class="columns">
      <div class="column is-3">
        <b-input v-model="filter" placeholder="Filter Users"></b-input>
        <b-checkbox v-model="showHiddenOnly" class="mt-2">Show only hidden</b-checkbox>
      </div>
      <div class="column is-9">
        <div class="level-right">
          <div class="level-item">
            <b-tooltip label="Users can request that an external legal representative be granted access to the AWG carbon calculator in order to provide advice and assistance for a specific transaction by submitting an ‘External legal representative access request’ form. If approved, the external legal representative will be granted access for the requested period of time. When the period of time ends, the external legal representative will no longer be able to access the AWG carbon calculator. Users can request an extension to this period of time."
                       position="is-left"
                       multilined>
              <i class="fas fa-question-circle"></i>
            </b-tooltip>&nbsp;
            <b-button class="is-light is-pulled-right" @click="createExternalRequest()"><i class="fas fa-user-plus"></i> External legal representative access request</b-button>
          </div>
          <div class="level-item"><b-button class="is-light is-pulled-right" @click="openAddUserModal({})"><i class="fas fa-user-plus"></i> Add user</b-button></div>
        </div>
      </div>
    </div>
    <b-table :data="filterUsers"
             :hoverable="true"
             :loading="isLoading"
             :mobile-cards="true"
             :paginated="true"
             default-sort="Name"
             pagination-position="both"
             :per-page="10"
             :pagination-simple="true">
      <b-table-column field="Name" label="Name" sortable v-slot="props">
        <a @click="openAddUserModal(props.row)">{{ props.row.Name }}</a>
      </b-table-column>
      <b-table-column field="GroupNameString" label="Group" v-slot="props">
        {{ props.row.GroupNameString }}
      </b-table-column>
      <b-table-column field="RoleNameString" label="Roles" v-slot="props">
        {{ props.row.RoleNameString }}
      </b-table-column>
      <b-table-column field="Email" label="Email" v-slot="props">
        {{ props.row.Email }}
      </b-table-column>
      <b-table-column v-slot="props">
        <div @click="sendWelcome(props.row)" class="button has-text-centered">
          <i class="fad fa-envelope pointer-cursor"></i>&nbsp;Resend welcome email
        </div>
      </b-table-column>
    </b-table>
  </div>
</template>

<script>
  import addUser from '@/components/modals/addUser.vue';
  import ExternalRequest from '@/components/modals/externalRequest.vue';
  export default {
    name: 'userAdmin',
    data() {
      return {
        users: [],
        filter: "",
        showHiddenOnly: false,
        groups: [],
        roles: []
      }
    },
    props: {
      group: String
    },
    computed: {
      filterUsers() {
        return this.users.filter((u) => {
          var result =
          (this.showHiddenOnly && u.IsHidden || !this.showHiddenOnly && !u.IsHidden) &&
          (
            (u.Name.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) ||
            (u.RoleNames.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) ||
            (u.GroupNames.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) ||
            (u.Email.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0)
          );
          return result;
        });
      }
    },
    methods: {
      async sendWelcome(user) {
        await this.$http.get("api/user/sendReset/" + user.Id)
          .then(resp => {
            if (resp.data) {
              this.$buefy.notification.open({
                duration: 6000,
                message: "Welcome email sent.",
                type: 'is-success',
              })
            }
            else {
              this.$buefy.notification.open({
                duration: 6000,
                message: "Welcome email failed to send.",
                type: 'is-danger',
              })
            }
          })
      },
      openBadNotification(message) {
        this.$buefy.notification.open({
          duration: 6000,
          message: message,
          type: 'is-danger',
        })
      },
      getUsers() {
        this.$http.get("api/user/groupManager")
          .then(resp => {
            this.users = resp.data;

            this.users.forEach(user => {
              user.GroupNames = [];
              user.Groups.forEach(group => {
                user.GroupNames.push(group.Name);
              })
              if (user.CalculatorGroupName != null && !user.GroupNames.some(n => n == user.CalculatorGroupName))
                user.GroupNames.push(user.CalculatorGroupName);
              user.GroupNameString = user.GroupNames.join(", ");
            });

            this.users.forEach(user => {
              user.RoleNames = [];
              user.Roles.forEach(group => {
                user.RoleNames.push(group.Name);
              })
              user.RoleNameString = user.RoleNames.join(", ");
            });

            this.isLoading = false;
          }).catch(err => {
            console.error(err);
            this.isLoading = false;
          });
      },
      openAddUserModal(model) {
        this.$buefy.modal.open({
          parent: this,
          component: addUser,
          hasModalCard: true,
          width: 960,
          props: {
            Model: model
          },
          events: {
            refreshUsers: async (user) => {
              await this.getUsers();
            }
          }
        })
      },
      createExternalRequest() {
        this.$buefy.modal.open({
          parent: this,
          component: ExternalRequest,
          hasModalCard: true,
          width: 960,
        })
      }
    },
    created() {
      this.isLoading = true;
      if (this.group)
        this.$set(this, 'filter', this.group);

      this.getUsers();


    },

  }
</script>
